/**************************************************
 * Nombre:       Dialogo_Personal
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";

const Dialogo_Personal = ({cerrar, datos}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{px: 2, pb: 2}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Avatar src={datos.img} sx={{width: 160, height: 160}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography
                    sx={{color: theme.palette.primary.main, fontWeight: 800, fontSize: 18}}>{datos.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontSize: 16, fontWeight: 400}}>{datos.cargo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{fontSize: 16, fontWeight: 300, textAlign: 'center'}}>
                    {datos.descripcion}
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Personal